import PageHero from '../../components/PageHero';

function PolicyBody({ children }: { children: React.ReactNode }) {
  return (
    <section style={{ padding: '64px 0', background: '#FFFBF8' }}>
      <div className="container-wide" style={{ maxWidth: 800, fontSize: 15, color: '#4A2535', lineHeight: 1.85 }}>
        {children}
      </div>
    </section>
  );
}

export function TermsPage() {
  return (
    <>
      <PageHero badge="Legal" title="Terms of" titleAccent="Service" subtitle="The agreement between you and Micus for using micusify.com and related services." />
      <PolicyBody>
        <p><strong>Acceptance.</strong> By using Micus you agree to these Terms. If you do not agree, do not use the service.</p>
        <p><strong>Service.</strong> Micus provides software-assisted credit rating readiness and fundraising workflow tools. Formal regulated ratings or securities offerings, where required, are handled under applicable law with licensed parties.</p>
        <p><strong>Accounts & intake.</strong> Information you submit (name, email, phone) must be accurate. You are responsible for activity under your contact details.</p>
        <p><strong>Acceptable use.</strong> No scraping, abuse, fraud, or attempts to bypass security controls (including silent anti-bot protections).</p>
        <p><strong>Limitation.</strong> Micus is provided “as is” to the extent permitted by law. We are not liable for indirect or consequential damages arising from use of the platform.</p>
        <p><strong>Contact.</strong> one@lab63.org</p>
      </PolicyBody>
    </>
  );
}

export function PrivacyPage() {
  return (
    <>
      <PageHero badge="Legal" title="Privacy" titleAccent="Policy" subtitle="How Micus collects and uses personal information." />
      <PolicyBody>
        <p><strong>What we collect.</strong> Name, email, phone, country inferred from network (IP), and messages you send. We do not use browser GPS location prompts.</p>
        <p><strong>Why.</strong> To start credit rating as part of fundraising, respond to enquiries, and improve service security (including silent bot protection signals).</p>
        <p><strong>Sharing.</strong> We do not sell your personal data. We may share with processors who help us operate email, hosting, and analytics under contract.</p>
        <p><strong>Retention.</strong> We keep data as long as needed for the journey you started or as required by law.</p>
        <p><strong>Rights.</strong> Contact one@lab63.org to request access, correction, or deletion where applicable.</p>
      </PolicyBody>
    </>
  );
}

export function CookiesPage() {
  return (
    <>
      <PageHero badge="Legal" title="Cookie" titleAccent="Policy" subtitle="How micusify.com uses cookies and similar storage." />
      <PolicyBody>
        <p>We use essential cookies and local storage to run the site, remember preferences, and protect forms from automated abuse.</p>
        <p>We do not use visible third-party captcha cookies (such as Google reCAPTCHA) on the homepage intake.</p>
        <p>You can clear cookies in your browser; some features may stop working.</p>
      </PolicyBody>
    </>
  );
}

export function NotFoundPage() {
  return (
    <section style={{ padding: '96px 0', textAlign: 'center', background: '#FFFBF8' }}>
      <div className="container-wide">
        <p style={{ fontSize: 64, fontWeight: 900, color: '#C2185B', margin: 0 }}>404</p>
        <h1 style={{ fontSize: 28, fontWeight: 800 }}>Page not found</h1>
        <a href="/" style={{ color: '#C2185B', fontWeight: 700 }}>Back home</a>
      </div>
    </section>
  );
}
